import { buildQuery, requestJson } from "./apiClient";

/** Legacy pipeline partner organizations */
export function listPartners(params = {}) {
  return requestJson(`/api/admin/partner-organizations${buildQuery(params)}`);
}

export function getPartner(partnerOrganizationId) {
  return requestJson(`/api/admin/partner-organizations/${partnerOrganizationId}`);
}

export function createPartner(payload) {
  return requestJson("/api/admin/partner-organizations", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updatePartner(partnerOrganizationId, payload) {
  return requestJson(`/api/admin/partner-organizations/${partnerOrganizationId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function listPartnerUsers(partnerOrganizationId) {
  return requestJson(`/api/admin/partner-organizations/${partnerOrganizationId}/users`);
}

export function assignPartnerUser(partnerOrganizationId, payload) {
  return requestJson(`/api/admin/partner-organizations/${partnerOrganizationId}/users`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function removePartnerUser(partnerOrganizationId, userId) {
  return requestJson(
    `/api/admin/partner-organizations/${partnerOrganizationId}/users/${userId}`,
    { method: "DELETE" }
  );
}
